import { AxiosInstance } from 'axios';
import { CreateWorkspaceSignupInput, FinalizeWorkspaceSignupInput } from './inputs';
import { WorkspaceRef, WorkspaceSignupRef } from './refs';

export default class WorkspaceSignup {
    private basePath = '/api/workspace-signup';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Create new workspace signup
    create = async (input: CreateWorkspaceSignupInput): Promise<WorkspaceSignupRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Generate new workspace signup verification
    generateVerification = async (id: ID): Promise<WorkspaceSignupRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/verification`);
        return data;
    };

    // Finalize workspace signup
    finalize = async (id: ID, input: FinalizeWorkspaceSignupInput): Promise<WorkspaceRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/finalize`, input);
        return data;
    };
}
